import {Component, OnDestroy, OnInit} from '@angular/core';
import {CoreComponent} from '../../../core/component/core.component';
import {AlertService} from '../../../core/service/alert.service';
import {Router} from '@angular/router';
import {SecurityService} from '../../../core/service/security.service';
import {MessageService} from '../../../core/service/message.service';
import {ReportService} from '../../../service/report.service';
import {Tenant} from '../../../core/model/tenant';
import {LoggerService} from '../../../service/logger.service';
import {BudgetFormService} from '../../../service/budget-form.service';
import {Provider} from '../../../model/provider';
import ServiceUtils from '../../../core/utils/service.utils';

@Component({
    selector: 'app-retention-provider-report',
    templateUrl: './retention-provider-report.component.html',
    standalone: false
})
export class RetentionProviderReportComponent extends CoreComponent implements OnInit, OnDestroy {

  month = 'January';
  year = new Date().getFullYear();
  providers: Provider[] = [];
  providerId = '';

  constructor(private alertService: AlertService,
              protected router: Router,
              protected securityService: SecurityService,
              protected reportService: ReportService,
              protected messageService: MessageService,
              protected budgetFormService: BudgetFormService,
              protected loggerService: LoggerService) {
    super(alertService, router, securityService, loggerService);

  }

  clearFormErrors(): Map<string, string> {
    return new Map<string, string>();
  }

  ngOnInit(): void {
    this.loadProviders();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  monthChanged(month: string): void {
    this.month = month;
    this.loadProviders();
  }

  yearChanged(year: number): void {
    this.year = +year;
    this.loadProviders();
  }

  providerChanged(providerId: string): void {
    this.providerId = providerId;
  }
  loadProviders(): void {
    this.loading = true;
    this.budgetFormService.getProviders(this.month.toUpperCase(), this.year.toString())
      .subscribe(value => {
        this.providers = value;
        this.loading = false;
      }, error => this.processError(error));
  }


  generateEvent(): void {
    this.loading = true;
    this.reportService.exportBudgetFormRetentionsProviderToWord(this.month.toUpperCase(), this.year.toString(), this.providerId)
      .subscribe(
        response => {
          this.loading = false;
          const tenantFromStorage = ServiceUtils.getItem('tenant');
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(response);
          a.href = objectUrl;
          if (tenantFromStorage) {
            const tenant = JSON.parse(tenantFromStorage) as Tenant;
            a.download = `Reporte_Retenciones_proveedor${this.month.toUpperCase()}_${tenant.name?.replace(/\./g, '_')}`;
          }
          a.click();
          URL.revokeObjectURL(objectUrl);
        }, error => this.processError(error)
      );
  }
}
